import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    question: "What are the timings of the badminton academy?",
    answer: "The academy is open from 24 / 7 every day, including weekends.",
  },
  {
    question: "Do I need to bring my own badminton equipment?",
    answer: "We provide rackets and shuttlecocks, but you can bring your own if you prefer.",
  },
  {
    question: "How can I book a time slot?",
    answer: (
      <>
        You can book a slot by contacting the WhatsApp number (+918100376761) below.
        <div className="mt-4">
          <a
            href="https://wa.me/+918100376761"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500"
          >
            <img src="/whatsapp_icon.png" alt="WhatsApp" className="w-5 h-5" /> 
            Contact on WhatsApp
          </a>
        </div>
      </>
    ),
  },
  {
    question: "Are there different coaching levels available?",
    answer: "Yes, we offer beginner, intermediate, and advanced coaching sessions.",
  },
  {
    question: "Is there a membership fee?",
    answer: "Yes, we have monthly, hourly and weekend membership plans. Check our Pricing section for details.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="lg:max-w-2xl mx-auto">
          <h2 className="text-base font-semibold text-indigo-600 text-center">FAQs</h2>
          <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 text-center sm:text-5xl">
            Frequently Asked Questions
          </p>
          <div className="mt-10 space-y-6 text-gray-600">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b pb-4">
                <button
                  className="w-full flex justify-between items-center py-3 text-lg font-semibold text-gray-900 focus:outline-none"
                  onClick={() => toggleFAQ(index)}
                >
                  {faq.question}
                  {openIndex === index ? (
                    <ChevronUp className="size-5 text-indigo-600" />
                  ) : (
                    <ChevronDown className="size-5 text-indigo-600" />
                  )}
                </button>
                {openIndex === index && <p className="mt-2 text-gray-600">{faq.answer}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
